import { createContext } from 'react';

import { TAiReviewDto, TPrototypeReviewDto } from '@app-velocity/av-api-v2';

export type AiReviewContextType = {
  review: TAiReviewDto;
};

export const AiReviewContext = createContext<AiReviewContextType>({
  review: {} as TPrototypeReviewDto,
});
